import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faFilter, faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons";

import { isDefined } from "../../../../auxiliar/formatValidators";

const Collapse = ({
    isMainTitle,
    title,
    children,
    faModality = "dropdown",
    onStateChange,
    initialState = false,
}) => {
    const [isOpen, setIsOpen] = useState(initialState);

    const toggleCollapse = () => {
        onStateChange?.(!isOpen);
        setIsOpen(!isOpen);
    };

    return (
        <div
            className={`
            bg-base-100 rounded-xl shadow-md border border-base-300 transition-all duration-500 ease-in-out
            ${isOpen ? "shadow-primary/10 shadow-lg" : "shadow-primary/5"}
        `}
        >
            {/* Header */}
            <div
                onClick={toggleCollapse}
                className={`
                    ${isMainTitle ? "p-3" : "px-5 py-4"}
                    rounded-t-xl bg-gradient-to-r from-primary/5 via-primary/3 to-secondary/5
                    cursor-pointer hover:from-primary/8 hover:via-primary/5 hover:to-secondary/8
                    transition-all duration-500 ease-in-out group flex items-center justify-between
                    ${!isOpen ? "rounded-b-xl" : ""}
                `}
            >
                <div className="flex items-center gap-4">
                    {faModality === "filter" && (
                        <div
                            className={`${isMainTitle ? "w-10 h-10" : "w-8 h-8"}
                            rounded-lg flex items-center justify-center
                            transition-colors duration-500
                            bg-primary/10 group-hover:bg-primary/15
                        `}
                        >
                            <FontAwesomeIcon
                                icon={isOpen ? faFilterCircleXmark : faFilter}
                                className={`
                                    ${isMainTitle ? "text-lg" : "text-base"}
                                    text-primary
                                    transition-colors duration-500
                                `}
                            />
                        </div>
                    )}

                    <div className="flex flex-col">
                        {isMainTitle ? (
                            <h3 className="text-xl font-semibold text-primary group-hover:text-primary/80 transition-colors duration-500">
                                {isDefined(title) ? title : ""}
                            </h3>
                        ) : (
                            <span className="text-lg font-medium text-primary group-hover:text-primary/80 transition-colors duration-500">
                                {isDefined(title) ? title : ""}
                            </span>
                        )}
                        <span className="text-xs text-secondary/70 mt-1">
                            {faModality === "filter"
                                ? isOpen
                                    ? "Click para cerrar filtros"
                                    : "Click para abrir filtros"
                                : isOpen
                                  ? "Click para cerrar"
                                  : "Click para abrir"}
                        </span>
                    </div>
                </div>

                <div
                    className={`w-8 h-8 rounded-full bg-secondary/10 flex items-center justify-center group-hover:bg-secondary/20 transition-all duration-500
                    ${isOpen ? "rotate-180" : ""}
                `}
                >
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`
                            text-sm
                            text-secondary
                            transition-all duration-500
                        `}
                    />
                </div>
            </div>

            {/* Content */}
            <div
                className={`
                    transition-all duration-500 ease-in-out overflow-hidden border-primary/10
                    ${isOpen ? "max-h-screen bg-base-50 border-t rounded-b-xl" : "max-h-0"}
                `}
            >
                <div
                    className={`
                        bg-base-200 p-6
                        transition-all duration-500 ease-in-out
                        ${
                            isOpen
                                ? "opacity-100 transform translate-y-0 scale-100"
                                : "opacity-0 transform -translate-y-6 scale-95"
                        }
                    `}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Collapse;
